export const getDeviceMemory = t => {
  try {
    return navigator.deviceMemory || t("global.notSupported");
  } catch {
    return t("global.notSupported");
  }
};
